import { Box, useTheme, styled } from "@material-ui/core";
import "photoswipe/dist/default-skin/default-skin.css";
import "photoswipe/dist/photoswipe.css";
import React, { useState } from "react";
import Imgix, { buildURL } from "react-imgix";
import {
  Gallery as PhotoswipeGallery,
  Item as PhotoswipeItem
} from "react-photoswipe-gallery";
import SwipeableViewsControls from "../../../../../components/swipeable-views-controls";
import { ProductVariantType } from "../../../../../types/airgraft";
import {
  CustomSwipeableViews,
  IMAGE_DESKTOP_SIZE,
  CustomPodVideo
} from "./styles";

type Props = {
  productVariant: ProductVariantType;
  disableFloatingPod?: boolean;
};

function ProductDetailsGallery({ productVariant, disableFloatingPod }: Props) {
  const theme = useTheme();

  // Swipeable views index
  const [swipeableIndex, setSwipeableIndex] = useState(0);

  // Images url used for swipeable views & photoswipe
  const images =
    productVariant.images.length > 0
      ? productVariant.images
      : [productVariant.featuredImage];

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box position="relative">
        {!disableFloatingPod && <CustomPodVideo />}

        <PhotoswipeGallery
          shareButton={false}
          fullscreenButton={false}
          zoomButton={false}
          options={{
            bgOpacity: 0.8,
            showHideOpacity: true,
            tapToToggleControls: false,
            tapToClose: true
          }}
        >
          <CustomSwipeableViews
            index={swipeableIndex}
            onChangeIndex={setSwipeableIndex}
            enableMouseEvents
          >
            {images.map((image, index) => (
              <PhotoswipeItem
                key={index}
                original={buildURL(image.url, {
                  auto: "format,compress",
                  "max-w": 1920,
                  "max-h": 1920
                })}
                width={images[index]?.width}
                height={images[index]?.height}
              >
                {({ ref, open }) => (
                  <Imgix
                    src={images[index]?.url}
                    width={IMAGE_DESKTOP_SIZE}
                    height={IMAGE_DESKTOP_SIZE}
                    imgixParams={{
                      ar: "1",
                      fit: "crop",
                      auto: "format,compress"
                    }}
                    htmlAttributes={{
                      ref: ref as any,
                      onClick: open,
                      draggable: false
                    }}
                  />
                )}
              </PhotoswipeItem>
            ))}
          </CustomSwipeableViews>
        </PhotoswipeGallery>
      </Box>

      {images.length > 1 && (
        <SwipeableViewsControls
          amount={images.length}
          index={swipeableIndex}
          onItemClick={setSwipeableIndex}
        />
      )}
    </Box>
  );
}

export default React.memo(ProductDetailsGallery);
